var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavbarSwitch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 36,
    viewBox: "0 0 64 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 18,
    r: 17.5,
    fill: "white",
    fillOpacity: 0.8,
    stroke: "#EBEBEB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9079_97670)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.375 15.75L23 12.375M23 12.375L26.375 9M23 12.375H41M37.625 20.25L41 23.625M41 23.625L37.625 27M41 23.625H23",
    stroke: "#A6A6A6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9079_97670"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(20 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavbarSwitch);
export default __webpack_public_path__ + "static/media/navbar-switch.b4155a917ca2ee28d651f1ccae0b9374.svg";
export { ForwardRef as ReactComponent };